import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import blogDetailLink from '../../../utils/blogDetailLink'


class MostViewedOutput extends React.Component {

   render() {
      const { ids, data } = this.props
      
      return (
         <div className="categories">
            <div className="d-flex justify-content-between align-items-center">
               <h4 className="mb-0 border-0">Most Viewed</h4>
            </div>
            <div>
               <h4><span></span></h4>
            </div>
            <ul className="article-most-viewed-list">
               {data.allWpPost.nodes.filter(m => ids.includes(m.databaseId)).map((m, i) => (
                  <li>
                     <Link to={blogDetailLink(m)}>
                        <span className="count edition-page-color">{(i + 1)}</span>
                        <div className="">
                           <span className="title">{m.title}</span> 
                           {/*<span className="sub-title" style={{display:"block"}}>China Tech sell-off</span>*/}
                        </div>
                     </Link>
                  </li>
               ))}
            </ul>
        </div>
        ) 
    }
}

export default function MostViewed(props) {
   return (
      <StaticQuery
         query={graphql`
            query {
               allWpPost {
                  nodes {
                     title
                     slug
                     categories {
                        nodes {
                           slug
                           wpParent {
                              node {
                                id
                              }
                           }
                        }
                     }
                     databaseId
                  }
               }
            }
         `}
         render={data => <MostViewedOutput data={data} {...props} />}
      />
   )
}
